import React from 'react';
import { ILinkStyles, Link, getTheme } from '@fluentui/react';
import { isDarkTheme } from 'theme';

interface EvidenceTable {
  rows: [string, string | number][];
  className?: string;
}

function renderRowValue(value: string | number, linkStyles: ILinkStyles): JSX.Element {
  if (typeof value === 'string' && (value.startsWith('https://') || value.startsWith('http://'))) {
    return (
      <Link underline styles={linkStyles} href={value} target="blank" rel="noopener noreferrer">
        {value}
      </Link>
    );
  }

  return <>{value}</>;
}

export const EvidenceTable: React.FunctionComponent<EvidenceTable> = props => {
  const { palette } = getTheme();

  const linkStyles: ILinkStyles = {
    root: {
      backgroundColor: isDarkTheme() ? 'none' : palette.white,
      selectors: { ':visited': { color: palette.blue } }
    }
  };

  return (
    <div>
      {props.rows &&
        props.rows.map((row: [string, string | number]) => {
          return (
            <div key={row[0]}>
              <span className="font-weight-bold">{row[0]}</span>
              <p className="pb-2">
                {renderRowValue(typeof row[1] == 'object' ? JSON.stringify(row[1]) : row[1], linkStyles)}
              </p>
            </div>
          );
        })}
    </div>
  );
};

export default EvidenceTable;
